import { render, staticRenderFns } from "./Consultants.vue?vue&type=template&id=ff748d8a&scoped=true&"
import script from "./Consultants.vue?vue&type=script&lang=js&"
export * from "./Consultants.vue?vue&type=script&lang=js&"
import style0 from "./Consultants.vue?vue&type=style&index=0&id=ff748d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff748d8a",
  null
  
)

export default component.exports